function VehicleRetrieveSavedQuoteResponseTransformer($filter, jsonMapper, Util) {
    // transform functions
    var transformers = {
        camelcase: function(value) {
            if(value) {
                return value.charAt(0).toUpperCase() + value.slice(1);
            }
        },        
        date: function(dateString) {
            var date = moment(dateString, 'YYYY-MM-DD') ;
            return date.format('DD/MM/YYYY') ;
        },
        today : function() {
            return  moment().tz("Australia/Sydney").format('DD/MM/YYYY') ;
        },
        convertGender: function(gender) {
            var gc = {
                M : 'male',
                F : 'female',
                I : 'intersex',
            };
            return gc[gender] ;
        },
        yesNo: function(value) {
            return value == 'yes' ? true : false;
        },
        defaultNull: function(value) {
            return null;
        },
        checkbox: function(value) {
        },
        state: function(state) {
            if ( state )
                return state.replace('AU_', '');
        },
        coverType: function(coverType) {
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                return 'third_party';
            }
            return coverType;
        },
        purchaseMonthFromMonthYear: function(monthYear) {
            if(monthYear){
                var month = monthYear.split('-')[1];
                return month;
            }else{
                return '';
            }

        },
        purchaseYearFromMonthYear: function(monthYear) {
            if(monthYear){
                var year = monthYear.split('-')[0];
                return year;
            }else{
                return '';
            }
        },
        thirdPartyPref: function(coverType) {
            if(coverType === 'comprehensive') {
                return null;
            }

            if(coverType==='third_party'){
                return 'standard';
            }
            return coverType;
        },
        financeWith: function(financeWith) {

            if(financeWith) {
                var carFinance = {};

                carFinance.label = financeWith.name;
                carFinance.value = financeWith.publicID;

                return carFinance;
            }
        },
        yearsHeld: function(years) {
            var yearsHeld;

            switch (years) {
                case '7':
                    yearsHeld = 'lessThan_1';
                    break;
                case '6':
                    yearsHeld = 'greaterThan_5';
                    break;
                default:
                    yearsHeld = years;
            }

            return yearsHeld;
        },
        hasModifications: function(modifications) {
            return modifications.length > 1 ? true : false;
        },
    };
    function transformPerson(person) {
        var transformMapping = {
                'returnObject.title':                                   '=_input.prefix',
                'returnObject.firstName':                               '=_input.firstName',
                'returnObject.lastName':                                '=_input.lastName',
                'returnObject.gender':                                  '=_input.gender',
                'returnObject.dateOfBirth':                             '=_input.dateOfBirth'
            },
            convertMapping = {
                'returnObject.title':                                   transformers.camelcase,
                'returnObject.gender':                                  transformers.convertGender,
                'returnObject.dateOfBirth':                             transformers.date
            };
        var transformedPerson = jsonMapper.convert(jsonMapper.transform(person, transformMapping), convertMapping);
        return transformedPerson.returnObject;
    }

    function transformDriver(driver) {

        // transformPersonalHistory(driver.driverHistory);

        var transformMapping = {
            'returnObject.yearsHeld':                                       '=_input.yearsLicenced',
            'returnObject.licenceType':                                     '=_input.licenceType',
            'returnObject.noClaimBonus':                                    '=_input.noClaimBonus',
            'returnObject.maxNoClaimBonusLength':                           '=_input.maxNoClaimBonusLength',
            'returnObject.previousInsurer':                                 '=_input.previousInsurer',
            'returnObject.NSWDemeritPoints':                                '=_input.zeroDemerits',
            'returnObject.fourYears_chargedOrConvictedOffences':            '=_input.hasInfringement',
            // 'returnObject.fourYears_chargedOrConvictedOffencesDetails':      '=_input.driverHistory',
            'returnObject.fourYears_licenceRSDC':                           '=_input.hasLostLicence',
            // 'returnObject.fourYears_licenceRSDCDetails':                 '=_input.driverHistory',
            'returnObject.fourYears_vehicleAccidentsClaims':                '=_input.hasClaim',
            // 'returnObject.fourYears_vehicleAccidentsClaimsDetails':          '=_input.driverHistory',
            'returnObject.tenYears_chargedOrConvictedOffences':             '=_input.hasConviction',
            // 'returnObject.tenYears_chargedOrConvictedOffencesDetails':      '=_input.driverHistory',
            },
            convertMapping = {
                'returnObject.yearsHeld':                                   transformers.yearsHeld,
                'returnObject.NSWDemeritPoints':                            transformers.yesNo,

                'returnObject.fourYears_chargedOrConvictedOffences':        transformers.defaultNull,
                // 'returnObject.fourYears_chargedOrConvictedOffencesDetails': transformers.history,

                'returnObject.fourYears_licenceRSDC':                       transformers.defaultNull,
                 // 'returnObject.fourYears_licenceRSDCDetails':                transformers.history,

                'returnObject.fourYears_vehicleAccidentsClaims':            transformers.defaultNull,
                // 'returnObject.fourYears_vehicleAccidentsClaimsDetails':      transformers.history,

                'returnObject.tenYears_chargedOrConvictedOffences':         transformers.defaultNull,
                // 'returnObject.tenYears_chargedOrConvictedOffencesDetails':  transformers.history
            };

        var transformedDriver = jsonMapper.convert(jsonMapper.transform(driver, transformMapping), convertMapping);
        var returnObject = transformedDriver.returnObject;
        if(driver.person) {
            returnObject.person = transformPerson(driver.person);
        }

         // extract driver history
        returnObject.fourYears_chargedOrConvictedOffencesDetails = [];
        returnObject.fourYears_vehicleAccidentsClaimsDetails = [];
        returnObject.tenYears_chargedOrConvictedOffencesDetails = [];
        returnObject.fourYears_licenceRSDCDetails = [];

        if (!!driver.driverHistory) {
            driver.driverHistory.forEach(function(record) {
                var matchedPattern = {};

                switch (record.pattern.filter1) {
                    case 'infringement_demerit':
                    // case 'infringement_licence':
                        returnObject.fourYears_chargedOrConvictedOffencesDetails.push(
                            extractHistory(globals.fourYears_offences.options, record)
                        );
                        break;
                    case 'infringement_licence':
                        returnObject.fourYears_licenceRSDCDetails.push(
                            extractHistory(globals.incidents.options, record)
                        );
                        break;
                    case 'claim' :
                        returnObject.fourYears_vehicleAccidentsClaimsDetails.push(
                            extractHistory(globals.accidents.options, record));
                        break;
                    case 'conviction' :
                        returnObject.tenYears_chargedOrConvictedOffencesDetails.push(
                            extractHistory(globals.tenYears_offences.options, record)
                        );
                        break;

                }
            });
        }

        returnObject.fourYears_chargedOrConvictedOffences = returnObject.fourYears_chargedOrConvictedOffencesDetails.length > 0 ;
        returnObject.fourYears_vehicleAccidentsClaims = returnObject.fourYears_vehicleAccidentsClaimsDetails.length > 0 ;
        returnObject.tenYears_chargedOrConvictedOffences = returnObject.tenYears_chargedOrConvictedOffencesDetails.length > 0 ;
        returnObject.fourYears_licenceRSDC = returnObject.fourYears_licenceRSDCDetails.length > 0 ;

        return returnObject;
    }

    function extractHistory(collection, record) {
        var matchedPattern = {};
        var month = {};
        var year = {};

        matchedPattern = collection.find(function(opt) {
            return opt.publicID == record.pattern.publicID;
        });

        month.label = month.value = moment(record.month, 'MM').format('MMMM') ; // Util.capitalize(record.month.toString());
        year.label = year.value = Util.capitalize(record.year.toString());

        record.description = matchedPattern;
        record.month = month;
        record.year = year;

        delete record.pattern;

        return record;
    }
        // WIP deconstruction of driver history to separate them into the different tables
        // function transformPersonalHistory(history) {
        //  console.info('history', history);
        //  console.info('labels', labelService.getOptionsFor('fourYears_chargedOrConvictedOffencesDetails'));
        // }

    function transformPolicyHolder(holder) {

        var transformMapping = {
            'returnObject.title':                                           '=_input.prefix',
            'returnObject.firstName':                                       '=_input.firstName',
            'returnObject.lastName':                                        '=_input.lastName',
            'returnObject.gender':                                          '=_input.gender',
            'returnObject.dateOfBirth':                                     '=_input.dateOfBirth',
            'returnObject.fourYears_chargedOrConvictedOffences':            '=_input.hasInfringement',
            'returnObject.fourYears_licenceRSDC':                           '=_input.hasLostLicence',
            'returnObject.fourYears_vehicleAccidentsClaims':                '=_input.hasClaim',
            'returnObject.tenYears_chargedOrConvictedOffences':             '=_input.hasConviction'
            },
            convertMapping = {
                'returnObject.title':                                       transformers.camelcase,
                'returnObject.gender':                                      transformers.convertGender,
                'returnObject.dateOfBirth':                                 transformers.date,
                'returnObject.fourYears_chargedOrConvictedOffences':        transformers.yesNo,
                'returnObject.fourYears_licenceRSDC':                       transformers.yesNo,
                'returnObject.fourYears_vehicleAccidentsClaims':            transformers.yesNo,
                'returnObject.tenYears_chargedOrConvictedOffences':         transformers.yesNo
            };

        var transformedPolicyHolder = jsonMapper.convert(jsonMapper.transform(holder, transformMapping), convertMapping);

        return transformedPolicyHolder.returnObject;
    }

    /**
     * Transforms the retrievedQuoteRepsonse into a format that can be injected into the userInputRepository
     * The returned value will populate all the forms in the quote process
     * @param {Object} retrievedQuoteResponse                   Response object from the retrieveSavedQuote service
     * @returns {Object}                                        Transformed object ready to inject into the userInputRepository
     */
    function transform(retrievedQuoteResponse) {
        console.info('retrievedQuoteResponse', retrievedQuoteResponse);

       var transformMapping = {
				// getStarted
				'returnObject.getStarted.policyStartDate':
					'=_input.periodStartDate',
				'returnObject.getStarted.personOrCompany':
					'=_input.policyHolders.0.contact.contactType',

				// aboutYourCar
				'returnObject.aboutYourCar.address':
					'=_input.vehicles.0.garageAddress',

				// carDetails
				'returnObject.carDetails.locationParked':
					'=_input.vehicles.0.garageType',
				'returnObject.carDetails.primaryCarUse':
					'=_input.vehicles.0.primaryUsage',
				'returnObject.carDetails.colour': '=_input.vehicles.0.colour',
				'returnObject.carDetails.last12Months':
					'=_input.vehicles.0.recentPurchase',
				'returnObject.carDetails.carCost':
					'=_input.vehicles.0.purchasePrice',
				'returnObject.carDetails.originalOwner':
					'=_input.vehicles.0.originalOwner',
				'returnObject.carDetails.whenDidYouBuyYear':
					'=_input.vehicles.0.purchaseMonthYear',
				'returnObject.carDetails.whenDidYouBuyMonth':
					'=_input.vehicles.0.purchaseMonthYear',
				'returnObject.carDetails.carFinance':
					'=_input.vehicles.0.financeType',
				'returnObject.carDetails.financeWith':
					'=_input.vehicles.0.financeCompany',
				'returnObject.carDetails.existingDamage':
					'=_input.vehicles.0.unrepairedDamage',
				'returnObject.carDetails.writtenEvidence':
					'=_input.vehicles.0.evidenceOfValueOrPrice',
				'returnObject.carDetails.salvageValue':
					'=_input.vehicles.0.salvageValue',
				'returnObject.carDetails.modificationsBuilt':
					'=_input.vehicles.0.afterMarketModifications',

				//tell us a bit more -------------------------------------
				'returnObject.tellUsABitMore.yourEmailAddress': '=_input.email',
				'returnObject.tellUsABitMore.promotionalCode':
					'=_input.campaignCode',
				'returnObject.stampDutyExemption.isSmallBusiness':
					'=_input.vehicles.0.isSmallBusiness',

				//driver
				// 'vehicleForm.driver.paymentOptions':             '=_input.?',

				//quote
				'returnObject.insuredExcessValue.coverType':
					'=_input.vehicles.0.coverType',
				'returnObject.insuredExcessValue.comprehensivePref':
					'=_input.vehicles.0.sumInsuredType',
				'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':
					'=_input.vehicles.0.coverType',
				'returnObject.insuredExcessValue.vehicleExcess':
					'=_input.vehicles.0.excess.voluntaryVehicleExcessOptions',
				'returnObject.insuredExcessValue.standardVehicleExcess':
					'=_input.vehicles.0.excess.standardVehicleExcess',
				'returnObject.insuredExcessValue.voluntaryVehicleExcess':
					'=_input.vehicles.0.excess.voluntaryVehicleExcess',
				'returnObject.insuredExcessValue.ageExcessTier1':
					'=_input.vehicles.0.excess.ageExcessTier1',
				'returnObject.insuredExcessValue.ageExcessTier2':
					'=_input.vehicles.0.excess.ageExcessTier2',
				'returnObject.insuredExcessValue.undeclaredDriverTier2':
					'=_input.vehicles.0.excess.undeclaredDriverTier2',
				'returnObject.insuredExcessValue.inexperiencedDriver':
					'=_input.vehicles.0.excess.inexperiencedDriver',
				'returnObject.insuredExcessValue.agreedValue':
					'=_input.vehicles.0.sumInsuredAmount',

				// optional benefits
				'returnObject.optionalBenefits.QPMMotVehHireCar':
					'=_input.vehicles.0.coverageOptions.0.selected',
				'returnObject.optionalBenefits.QPMMotVehWindscreen':
					'=_input.vehicles.0.coverageOptions.1.selected',
				'returnObject.optionalBenefits.QPMMotVehNCB':
					'=_input.vehicles.0.coverageOptions.2.selected',
				'returnObject.optionalBenefits.QPMMotVehLifetimeNCB':
					'=_input.vehicles.0.coverageOptions.2.selected',
				// registration details
				'returnObject.aboutYourCar.regoSearchResponse':
					'=_input.vehicles.0.vehicleInfo',
				'returnObject.aboutYourCar.retrievedQuoteRego.rego':
					'=_input.vehicles.0.registrationNumber',
				'returnObject.aboutYourCar.retrievedQuoteRego.state':
					'=_input.vehicles.0.garageAddress.state',
				'returnObject.tellUsYourRegoNumber.regoNumber':
					'=_input.vehicles.0.registrationNumber',
				// Contact
				'returnObject.mainPolicyHolderContact.passwordQuestion':
					'=_input.policyHolders.0.contact.passwordQuestion',
				'returnObject.mainPolicyHolderContact.passwordAnswer':
					'=_input.policyHolders.0.contact.passwordAnswer',
				'returnObject.mainPolicyHolderContact.primaryPhone':
					'=_input.policyHolders.0.contact.primaryPhone',
				'returnObject.mainPolicyHolderContact.personalContactDetailsMailingPreference':
					'=_input.documentDeliveryMethod',

				'returnObject.mainPolicyHolderContact.emailAddress1':
					'=_input.email'
			},
			convertMapping = {
				'returnObject.carDetails.colour': transformers.camelcase,
				'returnObject.getStarted.policyStartDate': transformers.date,
				'returnObject.carDetails.financeWith': transformers.financeWith,
				'returnObject.retrievedQuoteRego.state': transformers.state,
				'returnObject.insuredExcessValue.coverType':
					transformers.coverType,
				'returnObject.insuredExcessValue.thirdPartyOrThirdPartyFireAndTheft':
					transformers.thirdPartyPref,
				'returnObject.carDetails.whenDidYouBuyYear':
					transformers.purchaseYearFromMonthYear,
				'returnObject.carDetails.whenDidYouBuyMonth':
					transformers.purchaseMonthFromMonthYear
			};
        var transformedQuote = jsonMapper.convert(jsonMapper.transform(retrievedQuoteResponse, transformMapping), convertMapping);

        if(retrievedQuoteResponse.vehicles[0].primaryUsage) {
            var usage = retrievedQuoteResponse.vehicles[0].primaryUsage;
			switch (usage) {
				case 'commercial':
                transformedQuote.returnObject.carDetails.commercialActivityType = retrievedQuoteResponse.vehicles[0].businessUsage;
					break;
				case 'business':
                    transformedQuote.returnObject.carDetails.businessActivityType = retrievedQuoteResponse.vehicles[0].businessUsage;
					break;
			}            
        }

        // set primary phone number to mobile phone
        if(retrievedQuoteResponse.policyHolders[0].contact.cellPhone) {
            transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.cellPhone;
        }

        // set primary phone number to home phone
        if(retrievedQuoteResponse.policyHolders[0].contact.homePhone) {
            transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.homePhone;
        }

        // set primary phone number to work phone
        if(retrievedQuoteResponse.policyHolders[0].contact.workPhone) {
            transformedQuote.returnObject.mainPolicyHolderContact.primaryPhoneNumber = retrievedQuoteResponse.policyHolders[0].contact.workPhone;
        }

        // set comprehensive preference to null if the coverType is third party
        if(retrievedQuoteResponse.vehicles[0].coverType.length && retrievedQuoteResponse.vehicles[0].sumInsuredType.length) {
            var coverType = retrievedQuoteResponse.vehicles[0].coverType;
            if(coverType === 'third_party' || coverType === 'third_party_fire_theft') {
                transformedQuote.returnObject.insuredExcessValue.comprehensivePref = null;
            }
        }

        // set optional modifications
        // console.info(retrievedQuoteResponse.vehicles[0].vehicleInfo.selectedEquipments[0]);
        if(retrievedQuoteResponse.vehicles[0].vehicleInfo &&
            retrievedQuoteResponse.vehicles[0].vehicleInfo.selectedEquipments &&
            retrievedQuoteResponse.vehicles[0].vehicleInfo.selectedEquipments.length) {

            transformedQuote.returnObject.carDetails.modifications = true;

            transformedQuote.returnObject.carDetails.modificationsOptions = {};

            var selectedEquipments = retrievedQuoteResponse.vehicles[0].vehicleInfo.selectedEquipments;

            selectedEquipments.forEach(function(mod) {
                // console.info(mod.optionKey);
                transformedQuote.returnObject.carDetails.modificationsOptions[mod.optionKey] = true;
            });
        } else {
             transformedQuote.returnObject.carDetails.modifications = false;
        }

        if(retrievedQuoteResponse.vehicles[0] &&
            retrievedQuoteResponse.vehicles[0].afterMarketMods &&
            retrievedQuoteResponse.vehicles[0].afterMarketMods.length) {

            transformedQuote.returnObject.carDetails.modificationsBuilt = true;

            transformedQuote.returnObject.carDetails.modificationsBuiltOptions = {};

            var afterMarketMods = retrievedQuoteResponse.vehicles[0].afterMarketMods;

            afterMarketMods.forEach(function(mod) {
                transformedQuote.returnObject.carDetails.modificationsBuiltOptions[mod] = true;
            });
        }

        // sort drivers to put mainDriver first in the list
        if(retrievedQuoteResponse.vehicles && retrievedQuoteResponse.vehicles.length && retrievedQuoteResponse.vehicles[0].drivers) {
            var drivers = $filter('orderBy')(retrievedQuoteResponse.vehicles[0].drivers, function(driver) {
                return driver.driverUsage == 'main' ? 0 : 1;
            });
            transformedQuote.returnObject.driver = {};
            transformedQuote.returnObject.driver.drivers = [];
            drivers.forEach(function(driver, index) {
                transformedQuote.returnObject.driver.drivers.push(transformDriver(driver.driver));
            });
        }

        // set contact policy holders
        if(retrievedQuoteResponse.policyHolders && retrievedQuoteResponse.policyHolders.length) {
            var policyHolders = retrievedQuoteResponse.policyHolders;

            transformedQuote.returnObject.mainPolicyHolder = {};

            policyHolders.forEach(function(holder, index) {

                if(holder.mainHolder) {
                    transformedQuote.returnObject.mainPolicyHolder.mainPolicyHolder = true;
                    transformedQuote.returnObject.mainPolicyHolder = transformPolicyHolder(holder.contact);
                    transformedQuote.returnObject.mainPolicyHolder.policyHolders = [];

					if (holder.contact.contactType === 'company') {
						var authorisedPerson = holder.contact.authorisedPersons[0].person;

						transformedQuote.returnObject.aboutCompany = {};
						transformedQuote.returnObject.aboutCompany.name = holder.contact.name;
						transformedQuote.returnObject.aboutCompany.abn = holder.contact.abn;
						transformedQuote.returnObject.aboutCompany.email = holder.contact.emailAddress1;
						transformedQuote.returnObject.aboutCompany.officePhone = holder.contact.workPhone;
                        transformedQuote.returnObject.aboutCompany.companyAddress = holder.contact.primaryAddress;

                        transformedQuote.returnObject.companyContact = {};                        
						transformedQuote.returnObject.companyContact.primaryPhone = authorisedPerson.primaryPhone;
						transformedQuote.returnObject.companyContact.preferredNumber = authorisedPerson.homePhone || authorisedPerson.workPhone || authorisedPerson.cellPhone;
						transformedQuote.returnObject.companyContact.passwordQuestion = holder.contact.passwordQuestion;
                        transformedQuote.returnObject.companyContact.passwordAnswer = holder.contact.passwordAnswer;
                        transformedQuote.returnObject.companyContact
                            .companyContactDetailsMailingPreference = retrievedQuoteResponse.documentDeliveryMethod;
                        transformedQuote.returnObject.companyContact.address =
							authorisedPerson.primaryAddress;
                    } 
                  
                } else {
                    transformedQuote.returnObject.mainPolicyHolder.policyHolders.push(transformPolicyHolder(holder.contact));
                }
            });
        }

        console.info('final transform quote', transformedQuote.returnObject);

        return transformedQuote.returnObject;
    }
    return {
        transform: transform
    }
}
